import { ConstructionStoreState } from './ConstructionTypes';
import { ConstructionProjectEnum } from '@/app/domain/webservice-dto';

export const initialConstructionStore: ConstructionStoreState = {
    isDirty: false,
    isSubmitting: false,
    shareLink: '',
    data: {
        quoteId: undefined,
        avb: false,
        city: '',
        canton: '',
        startDate: new Date(),
        completionDate: undefined,
        duration: undefined,
        constructionProject: ConstructionProjectEnum.NewConstructionOrExtension,
        constructionSum: undefined,
        constructionType: undefined,
        newConstruction: undefined,
        supportStructureChanged: undefined,
        dangerZone: undefined,
        groundwater: undefined,
        advisorText: '',
        advisorMail: '',
        insurance: {
            deductible: undefined,
            earthquake: 'true',
            offeringLevel: undefined,
            premium: undefined,
            buildersRiskRatePremium: undefined,
            liabilityRatePremium: undefined,
            principalsLiabilityGuaranteedSum: '5000000',
        },
        postcode: '',
        principalLiability: {
            city: '',
            companyName: '',
            email: '',
            firstName: '',
            salutation: undefined,
            lastName: '',
            phoneNumber: '',
            postcode: '',
            street: '',
            languageOfCorrespondence: undefined,
        },
        ram: undefined,
        rock: undefined,
        street: '',
        overviewLink: '',
        underpinning: undefined,
    },
};

